import type { FC } from 'react';
import { List } from '@patternfly/react-core/dist/dynamic/components/List';
import { ListItem } from '@patternfly/react-core/dist/dynamic/components/List';

const PlainList: FC<PlainListProps> = ({ items }) =>
  items ? (
    <List isPlain>
      {items.map((i) => (
        <ListItem key={i}>{i}</ListItem>
      ))}
    </List>
  ) : null;

type PlainListProps = {
  items: string[];
};

export default PlainList;
